import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body{
    margin: 0;
    background: #fff;
    a{
      color: #FFF;
      text-decoration: none;
    }
  }
`;
